<template>
  <div>
    <div class="content-wrapper mb-3">
      <section class="content-header">
        <div
          class="overflow-hidden"
          style="border-bottom: 1px solid #00000017; height: 65px !important"
        >
          <div class="row mb-2">
            <div class="col-sm-6">
              <h1>Copy Tools</h1>
              <ol class="breadcrumb float-sm-left">
                <router-link
                  tag="li"
                  class="breadcrumb-item"
                  :to="{ name: 'Home' }"
                  >Home</router-link
                >
                <router-link
                  tag="li"
                  class="breadcrumb-item"
                  :to="{ name: 'Dashboard' }"
                  >Dashboard</router-link
                >
                <li class="breadcrumb-item active">Copy Tools</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <div class="container">
        <div class="row">
          <div
            class="d-flex justify-content-center align-items-center flex-column"
          >
            <div class="w-100">
              <!-- SELECT DOMAINS FROM COLUMN -->
              <div class="col-12">
                <v-card-title
                  class="d-flex flex-column align-items-start border pt-0 px-0 pb-0 border-radius-4"
                >
                  <div
                    class="d-flex justify-content-between align-items-center border-bottom w-100"
                  >
                    <div class="text-left py-1 pl-1 w-100">
                      <span class="step-number ml-2 mr-1">1</span>
                      <span style="font-size: 11px" class="mr-4">STEP</span>
                      <span class="font-size-11 font-weight-400"
                        >SELECT DOMAINS FROM:
                        {{
                          dmnsFrom[0] !== undefined ? dmnsFrom[0].length : 0
                        }}</span
                      >
                    </div>
                    <v-autocomplete
                      v-if="roles.includes('moder')"
                      v-model="selectedClientFrom"
                      label="Select a Client"
                      outlined
                      single-line
                      hide-details
                      dense
                      :items="getClients"
                      item-value="client_uid"
                      item-text="name"
                      class="py-4 pr-4 m-0"
                    ></v-autocomplete>
                  </div>
                  <div class="d-flex ml-2">
                    <v-tooltip left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-show="selectedDmnsFrom.length"
                          small
                          color="primary"
                          v-bind="attrs"
                          v-on="on"
                          @click="selectedDmnsFrom = []"
                        >
                          mdi-close-circle-outline
                        </v-icon>
                      </template>
                      <span>Click to purge selection.</span>
                    </v-tooltip>
                    <span class="ml-1" style="font-size: 45% !important">
                      SELECTED:
                      {{ selectedDmnsFrom.length }}
                    </span>
                  </div>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="searchDmnsFrom"
                    append-icon="mdi-magnify"
                    label="Search Domain"
                    single-line
                    hide-details
                    :disabled="loading"
                    :loading="loading"
                    class="border-radius-4 pt-0 px-1 mx-3 mt-3 mb-4"
                    style="width: 97%; border: 1px solid #d1d1d1 !important"
                  ></v-text-field>
                </v-card-title>

                <v-card class="elevation-1 border" style="margin: 0 !important">
                  <v-data-table
                    v-model="selectedDmnsFrom"
                    :headers="dmnsFromHeaders"
                    :loading="loading && !filteredDomainsFrom.length"
                    :items="filteredDomainsFrom"
                    item-key="id"
                    :show-select="!loading && !processLoading"
                    single-select
                    @toggle-select-all="
                      selectedDmnsFrom.length !== dmnsFrom[0].length
                        ? (selectedDmnsFrom = dmnsFrom[0])
                        : (selectedDmnsFrom = [])
                    "
                    class="elevation-1 border"
                    style="overflow-y: auto"
                  >
                    <template v-slot:[`item.url`]="{ item }">
                      <td
                        class="border-bottom border-left text-left my-2"
                        style="padding: 10px 16px"
                      >
                        {{ item.url }}
                      </td>
                    </template>
                    <template v-slot:[`item.domain_tags`]="{ item }">
                      <td class="border-left border-right border-top text-left">
                        <div
                          class="d-flex align-items-center my-2 overflow-auto"
                          v-if="
                            item.domain_tags !== undefined &&
                            item.domain_tags.length
                          "
                        >
                          <v-chip
                            v-for="tag in item.domain_tags"
                            :key="tag.id"
                            class="font-weight-medium text-sm-body-2 cursor-pointer mr-2"
                            :class="{
                              'red lighten-4': tag.type === 'geo',
                              'blue lighten-4': tag.type === 'adult',
                              'deep-orange lighten-4': tag.type === 'category',
                              'purple lighten-4': tag.type === 'server',
                            }"
                            label
                            small
                            @click.prevent="searchDmnsFrom = tag.name"
                            >{{ tag.name }}</v-chip
                          >
                        </div>
                      </td>
                    </template>
                    <template v-slot:[`item.status`]="{ item }">
                      <div class="d-flex align-items-center">
                        <span
                          class="inActiveStatusSign mr-1"
                          :class="{ activeStatusSign: item.is_active }"
                        >
                        </span>
                        <span
                          class="inActiveStatus"
                          :class="{ activeStatus: item.is_active }"
                        >
                          {{ item.is_active ? "Active" : "Inactive" }}
                        </span>
                      </div>
                    </template>
                  </v-data-table>
                </v-card>
              </div>

              <!-- SELECT DOMAINS TO COLUMN  -->
              <div class="col-12">
                <v-card-title
                  class="d-flex flex-column align-items-start border pt-0 px-0 pb-0 border-radius-4"
                >
                  <div
                    class="d-flex justify-content-between align-items-center w-100 border-bottom"
                  >
                    <div class="text-left py-1 pl-1 w-100">
                      <span class="step-number ml-2 mr-1">2</span>
                      <span style="font-size: 11px" class="mr-4">STEP</span>
                      <span class="font-size-11 font-weight-400"
                        >SELECT DOMAINS TO:
                        {{
                          dmnsTo[0] !== undefined ? dmnsTo[0].length : 0
                        }}</span
                      >
                    </div>
                    <v-autocomplete
                      v-if="roles.includes('moder')"
                      v-model="selectedClientTo"
                      label="Select a Client"
                      outlined
                      dense
                      single-line
                      hide-details
                      :items="getClients"
                      item-value="client_uid"
                      item-text="name"
                      class="py-4 pr-4 m-0"
                    ></v-autocomplete>
                  </div>
                  <div class="d-flex ml-2">
                    <v-tooltip left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-show="selectedDmnsTo.length"
                          small
                          color="primary"
                          v-bind="attrs"
                          v-on="on"
                          @click="selectedDmnsTo = []"
                        >
                          mdi-close-circle-outline
                        </v-icon>
                      </template>
                      <span>Click to purge selection.</span>
                    </v-tooltip>
                    <span class="ml-1" style="font-size: 45% !important">
                      SELECTED:
                      {{ selectedDmnsTo.length }}
                    </span>
                  </div>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="searchDmnsTo"
                    append-icon="mdi-magnify"
                    label="Search Domain"
                    :disabled="loading"
                    :loading="loading"
                    single-line
                    hide-details
                    class="border-radius-4 pt-0 px-1 mx-3 mt-3 mb-4"
                    style="width: 97%; border: 1px solid #d1d1d1 !important"
                  ></v-text-field>
                </v-card-title>

                <v-card class="elevation-1 border" style="margin: 0 !important">
                  <v-data-table
                    v-model="selectedDmnsTo"
                    :headers="dmnsToHeaders"
                    :items="filteredDomainsTo"
                    :loading="loading && !filteredDomainsTo.length"
                    item-key="id"
                    show-select
                    single-select
                    @toggle-select-all="
                      selectedDmnsTo.length !== dmnsTo[0].length
                        ? (selectedDmnsTo = dmnsTo[0])
                        : (selectedDmnsTo = [])
                    "
                    class="elevation-1"
                    style="overflow-y: auto"
                  >
                    <template v-slot:[`item.url`]="{ item }">
                      <td
                        class="border-bottom border-left text-left my-2"
                        style="padding: 10px 16px"
                      >
                        {{ item.url }}
                      </td>
                    </template>
                    <template v-slot:[`item.tags`]="{ item }">
                      <td class="border-top border-left border-right text-left">
                        <div
                          class="d-flex align-items-center my-2 overflow-auto"
                          v-if="
                            item.domain_tags !== undefined &&
                            item.domain_tags.length
                          "
                        >
                          <v-chip
                            v-for="tag in item.domain_tags"
                            :key="tag.id"
                            class="font-weight-medium text-sm-body-2 cursor-pointer mr-2"
                            :class="{
                              'red lighten-4': tag.type === 'geo',
                              'blue lighten-4': tag.type === 'adult',
                              'deep-orange lighten-4': tag.type === 'category',
                              'purple lighten-4': tag.type === 'server',
                            }"
                            label
                            small
                            >{{ tag.name }}</v-chip
                          >
                        </div>
                      </td>
                    </template>
                    <template v-slot:[`item.status`]="{ item }">
                      <div class="d-flex align-items-center">
                        <span
                          class="inActiveStatusSign mr-1"
                          :class="{ activeStatusSign: item.is_active }"
                        >
                        </span>
                        <span
                          class="inActiveStatus"
                          :class="{ activeStatus: item.is_active }"
                        >
                          {{ item.is_active ? "Active" : "Inactive" }}
                        </span>
                      </div>
                    </template>
                  </v-data-table>
                </v-card>
                <!-- </v-tab-item>
                </v-tabs-items> -->
              </div>

              <!-- SELECT TYPES COLUMN -->
              <div class="col-12 d-flex flex-column">
                <v-card-title
                  class="d-flex flex-column align-items-start border pt-0 px-0 pb-0 border-radius-4"
                >
                  <div class="text-left py-1 pl-1 w-100">
                    <span class="step-number ml-2 mr-1">3</span>
                    <span style="font-size: 11px" class="mr-4">STEP</span>
                    <span class="font-size-11 font-weight-400"
                      >SELECT TYPES: {{ types.length }}</span
                    >
                  </div>
                  <small class="ml-4" style="font-size: 45% !important">
                    SELECTED: {{ selectedTypes.length }}
                  </small>
                  <v-spacer></v-spacer>
                </v-card-title>
                <v-data-table
                  v-model="selectedTypes"
                  :headers="typesHeaders"
                  :items="types"
                  item-key="type"
                  hide-default-footer
                  show-select
                  class="elevation-1 w-100"
                  style="overflow-y: auto"
                  :items-per-page="-1"
                >
                  <template v-slot:[`item.type`]="{ item }">
                    <td
                      class="border-bottom border-left text-left my-2"
                      style="padding: 10px 16px"
                    >
                      {{ item.type }}
                    </td></template
                  >
                </v-data-table>
              </div>

              <!-- RECURRING DRIPS LIST -->
              <div
                class="col-12"
                v-if="selectedTypes.find((el) => el.type === 'Recurring Drips')"
              >
                <v-card-title
                  class="d-flex flex-column align-items-start border pt-0 px-0 pb-0 border-radius-4"
                >
                  <div
                    class="text-left border-bottom py-1 pl-1 w-100 position-relative"
                  >
                    <span class="step-number ml-2 mr-1">4.1</span>
                    <span style="font-size: 11px" class="mr-4">STEP</span>
                    <span class="font-size-11 font-weight-400"
                      >RECURRING DRIPS: {{ recurrings.length }}</span
                    >
                    <div
                      class="position-absolute d-flex align-items-center h-100"
                      style="top: 0; right: 7px; max-height: 200px"
                    >
                      <!-- <v-select
                        v-model="selectedRecurringStatus"
                        height="21"
                        :items="[
                          { text: 'Inactive', value: 0 },
                          { text: 'Active', value: 1 },
                        ]"
                        clearable
                        dense
                        class="v-combobox--type mr-3 mt-7"
                      ></v-select> -->
                      <!-- <v-menu bottom @input="toggleMenu">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="#007bff"
                            style="font-size: 12px"
                            dark
                            v-bind="attrs"
                            v-on="on"
                          >
                            Sorting by:
                          </v-btn>
                        </template>
                        <v-treeview
                          :items="itemsSendTime"
                          :open="openTreeview"
                          @update:active="treeviewActiveSendTime"
                          activatable
                          hoverable
                        >
                          <template #label="{ item }">
                            <span style="cursor: pointer">{{ item.name }}</span>
                          </template>
                        </v-treeview>
                        <v-treeview
                          :items="itemsAudienceFilters"
                          :open="openTreeview"
                          @input="treeviewActiveAudienceFilters"
                          selectable
                          multiple-active
                          activatable
                          hoverable
                        >
                          <template #label="{ item }">
                            <span style="cursor: pointer">{{ item.name }}</span>
                          </template>
                        </v-treeview>
                      </v-menu> -->
                    </div>
                  </div>
                  <div class="d-flex ml-2">
                    <v-tooltip left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-show="selectedRecurrings.length"
                          small
                          color="primary"
                          v-bind="attrs"
                          v-on="on"
                          @click="selectedRecurrings = []"
                        >
                          mdi-close-circle-outline
                        </v-icon>
                      </template>
                      <span>Click to purge selection.</span>
                    </v-tooltip>
                    <span class="ml-1" style="font-size: 45% !important">
                      SELECTED:
                      {{ selectedRecurrings.length }}
                    </span>
                    <v-select
                      v-model="selectedScheduleRelation"
                      :items="['Recurring', 'Tail Recurring']"
                      dense
                      style="position: absolute; top: 42px; right: 37px"
                    ></v-select>
                  </div>
                  <!-- <br class="d-none" />
                  <small class="ml-4" style="font-size: 45% !important">
                    SELECTED AUDIENCE FILTER:
                    {{
                      selectedAudienceFiltersForSorting.length
                        ? audienceList.find(
                            (el) =>
                              el.id === selectedAudienceFiltersForSorting[0]
                          )["name"]
                        : "All"
                    }}
                  </small>
                  <br class="d-none" />
                  <small class="ml-4" style="font-size: 45% !important">
                    SELECTED SEND TIME:
                    {{
                      selectedSendTimeForSorting.length
                        ? selectedSendTimeForSorting[0]
                        : "All"
                    }}
                  </small> -->
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="searchRecurrings"
                    append-icon="mdi-magnify"
                    label="Search ID or Title or Message"
                    :disabled="loading"
                    :loading="loading"
                    single-line
                    hide-details
                    class="border-radius-4 pt-0 px-1 mx-3 mt-3 mb-4"
                    style="width: 97%; border: 1px solid #d1d1d1 !important"
                  ></v-text-field>
                </v-card-title>
                <v-card class="elevation-1 border" style="margin: 0 !important">
                  <v-data-table
                    v-model="selectedRecurrings"
                    :headers="recurringsHeaders"
                    :items="filteredRecurrings"
                    :loading="!recurrings.length && loadingRecur"
                    show-select
                    @toggle-select-all="
                      selectedRecurrings.length !== recurrings.length
                        ? (selectedRecurrings = recurrings)
                        : (selectedRecurrings = [])
                    "
                    class="elevation-1"
                    style="overflow-y: auto"
                  >
                    <template v-slot:[`item.id`]="{ item }">
                      <td
                        class="border-left border-right"
                        style="width: 100px; height: 50px"
                      >
                        {{ item.id }}
                      </td></template
                    >
                    <template v-slot:[`item.title`]="{ item }">
                      <strong>{{ item.title }}</strong>
                      <br />
                      {{ item.body }}
                      <br />
                      <v-edit-dialog :return-value.sync="item.url">
                        <v-tooltip left>
                          <template v-slot:activator="{ on, attrs }">
                            <span
                              class="recurring-link"
                              v-bind="attrs"
                              v-on="on"
                            >
                              {{ item.url }}
                            </span>
                          </template>
                          <span>Click To Reveal</span>
                        </v-tooltip>
                        <template v-slot:input>
                          <v-text-field
                            v-model="item.url"
                            color="#2196f3"
                            single-line
                            counter
                          ></v-text-field>
                        </template>
                      </v-edit-dialog>
                    </template>
                    <template v-slot:[`item.status`]="{ item }">
                      <td class="text-left border-left">
                        <div class="d-flex align-items-center">
                          <span
                            class="inActiveStatusSign mr-1 border-left"
                            :class="{ activeStatusSign: item.is_active }"
                          >
                          </span>
                          <span
                            class="inActiveStatus"
                            :class="{ activeStatus: item.is_active }"
                          >
                            {{ item.is_active ? "Active" : "Inactive" }}
                          </span>
                        </div>
                      </td>
                    </template>
                  </v-data-table>
                </v-card>
              </div>

              <!-- WELCOME DRIPS LIST  -->
              <div
                class="col-12"
                v-if="selectedTypes.find((el) => el.type === 'Welcome Drips')"
              >
                <v-card-title
                  class="d-flex flex-column align-items-start border pt-0 px-0 pb-0 border-radius-4"
                >
                  <div class="text-left border-bottom py-1 pl-1 w-100">
                    <span class="step-number ml-2 mr-1">4.2</span>
                    <span style="font-size: 11px" class="mr-4">STEP</span>
                    <span class="font-size-11 font-weight-400"
                      >WELCOME DRIPS: {{ welcomes.length }}</span
                    >
                  </div>
                  <div class="d-flex ml-2">
                    <v-tooltip left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-show="selectedWelcomes.length"
                          small
                          color="primary"
                          v-bind="attrs"
                          v-on="on"
                          @click="selectedWelcomes = []"
                        >
                          mdi-close-circle-outline
                        </v-icon>
                      </template>
                      <span>Click to purge selection.</span>
                    </v-tooltip>
                    <span class="ml-1" style="font-size: 45% !important">
                      SELECTED:
                      {{ selectedWelcomes.length }}
                    </span>
                  </div>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="searchWelcomes"
                    append-icon="mdi-magnify"
                    label="Search ID or Title or Message"
                    :disabled="loading"
                    :loading="loading"
                    single-line
                    hide-details
                    class="border-radius-4 pt-0 px-1 mx-3 mt-3 mb-4"
                    style="width: 97%; border: 1px solid #d1d1d1 !important"
                  ></v-text-field>
                </v-card-title>
                <v-card class="elevation-1 border" style="margin: 0 !important">
                  <v-data-table
                    v-model="selectedWelcomes"
                    :headers="welcomesHeaders"
                    :items="filteredWelcomes"
                    :loading="!welcomes.length && loadingWelc"
                    show-select
                    @toggle-select-all="
                      selectedWelcomes.length !== welcomes.length
                        ? (selectedWelcomes = welcomes)
                        : (selectedWelcomes = [])
                    "
                    class="elevation-1"
                    style="overflow-y: auto"
                  >
                    <template v-slot:[`item.group_id`]="{ item }">
                      <td
                        class="border-left border-right"
                        style="width: 100px; height: 50px"
                      >
                        {{ item.group_id }}
                      </td></template
                    >
                    <template v-slot:[`item.title`]="{ item }">
                      <strong>{{ item.title }}</strong
                      ><br />{{ item.body }}<br />
                    </template>
                  </v-data-table>
                </v-card>
              </div>

              <!-- AUDIENCE FILTERS LIST -->
              <div
                class="col-12"
                v-if="
                  selectedTypes.find((el) => el.type === 'Audience Filters')
                "
              >
                <v-card-title
                  class="d-flex flex-column align-items-start border pt-0 px-0 pb-0 border-radius-4"
                >
                  <div class="text-left border-bottom py-1 pl-1 w-100">
                    <span class="step-number ml-2 mr-1">4.3</span>
                    <span style="font-size: 11px" class="mr-4">STEP</span>
                    <span class="font-size-11 font-weight-400"
                      >AUDIENCE FILTERS: {{ audience.length }}</span
                    >
                  </div>
                  <div class="d-flex ml-2">
                    <v-tooltip left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-show="selectedAudience.length"
                          small
                          color="primary"
                          v-bind="attrs"
                          v-on="on"
                          @click="selectedAudience = []"
                        >
                          mdi-close-circle-outline
                        </v-icon>
                      </template>
                      <span>Click to purge selection.</span>
                    </v-tooltip>
                    <span class="ml-1" style="font-size: 45% !important">
                      SELECTED:
                      {{ selectedAudience.length }}
                    </span>
                  </div>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="searchAudience"
                    append-icon="mdi-magnify"
                    label="Search ID or Name"
                    :disabled="loading"
                    :loading="loading"
                    single-line
                    hide-details
                    class="border-radius-4 pt-0 px-1 mx-3 mt-3 mb-4"
                    style="width: 97%; border: 1px solid #d1d1d1 !important"
                  ></v-text-field>
                </v-card-title>
                <v-card class="elevation-1 border" style="margin: 0 !important">
                  <v-data-table
                    v-model="selectedAudience"
                    :headers="audienceHeaders"
                    :search="searchAudience"
                    :items="audience"
                    :loading="!audience.length && loadingAud"
                    item-key="id"
                    show-select
                    @toggle-select-all="
                      selectedAudience.length !== audience.length
                        ? (selectedAudience = audience)
                        : (selectedAudience = [])
                    "
                    class="elevation-1"
                    style="overflow-y: auto"
                  >
                    <template v-slot:[`item.id`]="{ item }">
                      <td
                        class="border-left border-right"
                        style="width: 100px; height: 50px"
                      >
                        {{ item.id }}
                      </td></template
                    >
                  </v-data-table>
                </v-card>
              </div>
            </div>
          </div>

          <!-- CONFIRM BUTTON BLOCK -->
          <div
            class="d-flex justify-content-start pl-6"
            style="height: 40px; padding: 40px 0"
          >
            <button
              class="btn btn-success btn-sm p-2 px-4"
              style="margin: -21px 0"
              @click="copy"
              :disabled="
                (!selectedDmnsFrom.length &&
                  !selectedDmnsTo.length &&
                  !selectedTypes.length) ||
                loading ||
                processLoading
              "
              :loading="loading || processLoading"
            >
              Apply copy settings
            </button>
          </div>
        </div>

        <!-- SNACKBARS -->
        <!-- <v-snackbar v-model="error" :top="true" color="#FF0000" timeout="2000">
          {{ errorMsg || "Error" }}
          <template v-slot:action="{ attrs }">
            <v-btn color="white" text v-bind="attrs" @click="error = false">
              Close
            </v-btn>
          </template>
        </v-snackbar> -->

        <!-- Failure -->
        <transition
          class="animate__faster"
          enter-active-class="animate__animated animate__fadeIn animate__faster"
          leave-active-class="animate__animated animate__fadeOut animate__faster"
        >
          <FailureSnackbar
            v-if="failure"
            @update-failure="handleUpdateToFailureSnackbar"
            :message="errorMsg || 'Error'"
          />
        </transition>

        <!-- Success -->
        <transition
          class="animate__faster"
          enter-active-class="animate__animated animate__fadeIn animate__faster"
          leave-active-class="animate__animated animate__fadeOut animate__faster"
        >
          <SuccessSnackbar
            v-if="success"
            @update-success="handleUpdateToSuccessSnackbar"
            message="Copied!"
          />
        </transition>

        <!-- Warning -->
        <transition
          class="animate__faster"
          enter-active-class="animate__animated animate__fadeIn animate__faster"
          leave-active-class="animate__animated animate__fadeOut animate__faster"
        >
          <Warnings
            v-if="showWarningPopUp"
            @didClose="showWarningPopUp = false"
            :warningText="warningText"
          />
        </transition>
        <!-- <v-snackbar
          v-model="success"
          :top="true"
          color="#28a745"
          timeout="2000"
        >
          Copied!
          <template v-slot:action="{ attrs }">
            <v-btn color="white" text v-bind="attrs" @click="success = false">
              Close
            </v-btn>
          </template>
        </v-snackbar> -->
        <div
          class="spinner-border text-primary position-fixed"
          style="top: 50%; left: 55%"
          v-if="processLoading"
          role="status"
        >
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Drip from "../../apis/Drip.js";
import Domains from "../../apis/Domains.js";
import Segments from "../../apis/Segments.js";
import SuccessSnackbar from "../popUps/SuccessSnackbar.vue";
import FailureSnackbar from "../popUps/FailureSnackbar.vue";
import Warnings from "../popUps/Warnings.vue";
import Spinner from "../popUps/Spinner.vue";
import common from "../../mixins/common";

import moment from "moment";
import { mapState, mapActions, mapGetters } from "vuex";

import { chunk } from "../../utils";
import transformRecurringToStore from "../../transformers/recurring/transformRecurringToStore.js";
//import Worker from "../../workers/worker-to-transform-recurring.worker.js"

export default {
  name: "CopyTools",
  components: {
    Warnings,
    SuccessSnackbar,
    FailureSnackbar,
    Spinner,
    Error,
  },
  mixins: [common],
  data() {
    return {
      openTreeview: [],
      selectedSendTimeForSorting: [],
      selectedAudienceFiltersForSorting: [],
      itemsSendTime: [
        {
          id: 0,
          name: "Send Time:",
          children: [],
        },
      ],
      itemsAudienceFilters: [
        {
          id: 1,
          name: "Audience Filters:",
          children: [
            {
              id: "null",
              name: "Without audience",
            },
          ],
        },
      ],
      audienceList: [],
      loading: true,
      selectedWelcomes: [],
      selectedWelcomeGroups: [],
      selectedRecurringStatus: 1,
      selectedRecurrings: [],
      selectedAudience: "",
      processLoading: false,
      loadingRecur: true,
      loadingWelc: true,
      loadingAud: true,
      errorMsg: "",
      domains: [],
      error: false,
      success: false,
      searchDmnsFrom: "",
      searchDmnsTo: "",
      searchRecurrings: "",
      searchWelcomes: "",
      searchAudience: "",
      recurrings: [],
      welcomes: [],
      welcomesForCopying: [],
      audience: [],
      dmnsFrom: [],
      dmnsTo: [],
      types: [],

      selectedScheduleRelation: "Recurring",

      warningText: "",
      showWarningPopUp: false,

      dmnsFromHeaders: [
        {
          text: "Domains: ",
          align: "left",
          sortable: false,
          value: "url",
          class: "header-copy",
        },
        {
          text: "Tags: ",
          align: "left",
          sortable: true,
          value: "domain_tags",
          class: "header-copy",
        },
        {
          text: "Status: ",
          align: "left",
          value: "status",
          class: "header-copy",
        },
      ],
      dmnsToHeaders: [
        {
          text: "Domains: ",
          align: "left",
          sortable: false,
          value: "url",
        },
        {
          text: "Tags: ",
          align: "left",
          filterable: true,
          value: "tags",
        },
        {
          text: "Status: ",
          align: "left",
          value: "status",
        },
      ],
      typesHeaders: [
        {
          text: "Types: ",
          align: "left",
          sortable: false,
          value: "type",
        },
      ],
      recurringsHeaders: [
        {
          text: "ID",
          value: "id",
          align: "left",
          sortable: false,
        },
        {
          text: "Notification",
          value: "title",
          align: "left",
          sortable: false,
        },
        {
          text: "Status",
          value: "status",
          align: "left",
          sortable: false,
        },
      ],
      welcomesHeaders: [
        {
          text: "Group ID",
          value: "group_id",
          align: "left",
          sortable: false,
        },
        {
          text: "Message",
          value: "title",
          align: "left",
          sortable: false,
        },
      ],
      audienceHeaders: [
        {
          text: "ID",
          value: "id",
          align: "left",
          sortable: false,
        },
        {
          text: "Name",
          value: "name",
          align: "left",
          sortable: false,
        },
      ],
      failure: false,
      moderHeaders: {},
      selectedTypes: [],
      selectedClientTo: "",
      selectedClientFrom: "",
      selectedDmnsTo: [],
      selectedDmnsFrom: [],
      selectedRecurrings: [],
      selectedAudience: [],
      deepCopyOfAllRecurrings: [],
      deepCopyOfFilteredRecurringsAudience: [],
      deepCopyOfFilteredRecurringsByTime: [],
      recurringTemplate: {
        domain_id: null,
        type: "recurring",
        title: "",
        body: "",
        url: "",
        icon: "",
        event: null,
        offset: null,
        delivered: null,
        clicked: null,
        meta: null,
        customization: {},
        is_active: null,
        schedule: {},
        audiences: [],
      },
      worker: null
    };
  },
  async created() {
    if (this.roles.includes("moder")) {
      this.loading = true;

      await this.getAllClients();
    }

    if (!this.roles.includes("moder")) {
      await this.show(`?with[domain_tags]=*`)
        .then((response) => {
          this.dmnsTo.push(response.data.data);
          this.dmnsFrom.push(response.data.data);
        })
        .finally(() => {
          this.loading = false;
        });
    }

    queueMicrotask(() => {
      this.loading = false;
      this.types.push(
        {
          type: "Recurring Drips",
        },
        {
          type: "Welcome Drips",
        },
        {
          type: "Audience Filters",
        }
      );
    });
  },
  mounted() {
    // this.show(`?with[domain_tags]=*`).then((response) => {
    //   this.dmnsTo.push(response.data.data);
    //   this.dmnsFrom.push(response.data.data);
    //   this.types.push(
    //     {
    //       type: "Recurring Drips",
    //     },
    //     {
    //       type: "Welcome Drips",
    //     },
    //     {
    //       type: "Audience Filters",
    //     }
    //   );
    // });
  },
  beforeDestroy() {
    if (this.worker) {
      this.worker.terminate()
    }
  },
  computed: {
    ...mapState({
      segments: (state) => state.segment.segments,
      one: (state) => state.push.one,
      recurring: (state) => state.push.recurring,
    }),
    ...mapGetters(["getClients", "roles"]),

    isModerRole() {
      return this.roles.includes("moder");
    },
    filteredFilters() {
      return JSON.parse(JSON.stringify(this.audience)).filter((p) => {
        return (
          p.name.toLowerCase().indexOf(this.searchAudience.toLowerCase()) !==
            -1 || p.id == this.searchAudience
        );
      });
    },
    filteredWelcomes() {
      return this.welcomes.filter((p) => {
        return (
          p.title.toLowerCase().indexOf(this.searchWelcomes.toLowerCase()) !=
            -1 ||
          (null !== p.body &&
            p.body.toLowerCase().indexOf(this.searchWelcomes.toLowerCase()) !=
              -1) ||
          (null !== p.url &&
            p.url.toLowerCase().indexOf(this.searchWelcomes.toLowerCase()) !=
              -1) ||
          p.id.toString().includes(this.searchWelcomes) ||
          p.group_id.toString().includes(this.searchWelcomes)
        );
      });
    },
    filteredRecurrings() {
      return this.recurrings.filter((p) => {
        return (
          p.title.toLowerCase().indexOf(this.searchRecurrings.toLowerCase()) !=
            -1 ||
          (null !== p.body &&
            p.body.toLowerCase().indexOf(this.searchRecurrings.toLowerCase()) !=
              -1) ||
          (null !== p.url &&
            p.url.toLowerCase().indexOf(this.searchRecurrings.toLowerCase()) !=
              -1) ||
          p.id.toString().includes(this.searchRecurrings)
        );
      });
    },
    filteredDomainsTo() {
      if (this.dmnsTo[0] !== undefined) {
        return this.dmnsTo[0].filter((p) => {
          return (
            (p.url &&
              p.url.toLowerCase().indexOf(this.searchDmnsTo.toLowerCase()) !=
                -1) ||
            p.id.toString().includes(this.searchDmnsTo)
          );
        });
      } else {
        return [];
      }
    },
    filteredDomainsFrom() {
      if (this.dmnsFrom[0] !== undefined) {
        return this.dmnsFrom[0].filter((p) => {
          return (
            (p.url &&
              p.url.toLowerCase().indexOf(this.searchDmnsFrom.toLowerCase()) !=
                -1) ||
            p.id.toString().includes(this.searchDmnsFrom)
          );
        });
      } else {
        return [];
      }
    },
    comparator(a, b) {
      //console.log(a, b, "comparator");
      return b;
    },
  },
  methods: {
    ...mapActions([
      "getSegments",
      "getRecurringDrips",
      "getClientRecurringDrips",
      "getClientSegments",
      "show",
      "getAllClients",
      "obtainClientDomains",
    ]),

    headersClientFrom() {
      return this.selectedClientFrom.length || this.selectedClientTo.length
        ? {
            Accept: "application/json",
            client: this.selectedClientFrom,
          }
        : {
            Accept: "application/json",
          };
    },
    headersClientTo() {
      return this.selectedClientFrom.length || this.selectedClientTo.length
        ? {
            Accept: "application/json",
            client: this.selectedClientTo,
          }
        : {
            Accept: "application/json",
          };
    },
    calculatedHeight(index) {
      return index > 1 ? "-" + (48 * index - 48) + "px" : "";
    },
    tagsSearch(value, search, item) {
      return (
        item.url.includes(search) ||
        item.domain_tags.some((el) => el.name == search)
      );
    },
    toggleMenu() {
      this.openTreeview = [];
    },
    treeviewActiveAudienceFilters(array) {
      this.selectedAudienceFiltersForSorting = array;
    },
    treeviewActiveSendTime(array) {
      this.selectedSendTimeForSorting = array;
    },
    async getRecurringMessages() {
      this.loading = true;

      let scheduleRelation = null;

      switch (this.selectedScheduleRelation) {
        case "Recurring":
          scheduleRelation =
            "&with[schedules.audiences]=domain_id,id,name,query&whereRelation[schedules]=type::recurring";
          break;
        case "Tail Recurring":
          scheduleRelation =
            "&with[schedules]=*&whereRelation[schedules]=type::tail-recurring";
          break;
        default:
          break;
      }

      let additionalAudienceParams = this.selectedAudienceFiltersForSorting
        .length
        ? `&whereRelation[schedules.audiences]=segments.id::${this.selectedAudienceFiltersForSorting.toString()}`
        : "";
      let additionalTimeParams = this.selectedSendTimeForSorting.length
        ? `&whereRelation[schedules]=time::${this.selectedSendTimeForSorting}`
        : "";

      if (
        this.isModerRole && (!this.selectedClientFrom.length ||
        !this.selectedClientTo.length)
      ) {
        this.errorMsg = "Select a client."
        this.failure = true;

        return false;
      }

      try {
        for (let dmn of this.selectedDmnsFrom) {
          let offset = 0;
          let limit = 500;
          let hasMoreData = true;

          while (hasMoreData) {
            const params =
              `?order_by=id:desc&where[is_active]=${this.selectedRecurringStatus}&where[domain_id]=${dmn.id}` +
              `&limit=${limit}&offset=${offset}` +
              additionalAudienceParams +
              additionalTimeParams +
              scheduleRelation;

            const response = await this.getRecurringDrips({
              params,
              headers: this.headersClientFrom(),
            });

            const data = response.data.data;
            this.recurrings.push(...data);

            if (data.length < 500) {
              hasMoreData = false;
            } else {
              offset += limit;
            }
          }
        }
      } catch (err) {
        this.error = err;
      } finally {
        this.loading = false;
        this.loadingRecur = false;
      }
    },
    async sendRequestToCopyRecurringMessages(domainId) {
      this.processLoading = true;

      if (!this.selectedRecurrings.length) {
        this.processLoading = false;
        return;
      }

      try {
        const chunks = chunk(this.selectedRecurrings, 500);
        // var promises = [];

        for (let chunk of chunks) {
          const transformedRecurringChunks = chunk.map((recurring) => {
            return transformRecurringToStore(recurring, domainId);
          });

          await Drip.createOrUpdate(
              "recurring",
              transformedRecurringChunks,
              false,
              this.isModerRole ? this.selectedClientTo : null
            ).then((response) => {
                if (response.status === 200) {
                    return { success: true, response };
                } else {
                    throw new Error(`Request failed with status ${response.status}`);
                }
            })
            .catch((error) => {
                console.error("Request failed:", error);
                return { success: false, error };
            });

          //promises.push(request)
        }

        // const results = await Promise.allSettled(promises);

        // const allSuccessful = results.every(
        //     (result) => result.status === "fulfilled" && result.value.success
        // );

        // if (allSuccessful) {
        //     console.log("All requests returned 200 status!");
        //     this.handleSuccess();
        //     this.processLoading = false;
        // } else {
        //     console.error("Some requests failed:", results);
        // }
      } catch (error) {
        console.error(error);

        this.handleError(error);
      } finally {
        if (!this.failure && !this.errorMsg) {
          this.handleSuccess();
        }

        this.processLoading = false;
      }
      // this.processLoading = true;

      // if (!this.selectedRecurrings.length) {
      //   this.processLoading = false;
      //   return;
      // }

      // //const chunks = chunk(this.selectedRecurrings, 500);
      // try {
      //   if (window.Worker) {
      //     this.worker = new Worker()
      //   } else {
      //     throw new Error("Web Worker: Worker is not available.");
      //   }

      //   this.worker.postMessage({
      //     selectedRecurrings: this.selectedRecurrings, 
      //     domains: this.selectedDmnsTo, 
      //     createUrlParams: { 
      //       withReplaceUrlButtons: false,
      //       clientUid: this.isModerRole ? this.selectedClientTo : null
      //     }
      //   })

      //   this.worker.onmessage = (e) => {
      //     let { transformedRecurringChunks } = e.data;
      //     console.log("🚀 ~ sendRequestToCopyRecurringMessages ~ transformedRecurringChunks:", transformedRecurringChunks)
      //   };
      //   //for (let chunk of chunks) {
      //     // const transformedRecurringChunks = chunk.map((recurring) => {
      //     //   return transformRecurringToStore(recurring, domainId);
      //     // });

      //     // await Drip.createOrUpdate(
      //     //   "recurring",
      //     //   transformedRecurringChunks,
      //     //   false,
      //     //   this.isModerRole ? this.selectedClientTo : null
      //     // );
      //   //}
      // } catch (error) {
      //   console.error(error);

      //   this.handleError(error);
      // } finally {
      //   if (!this.failure && !this.errorMsg) {
      //     this.handleSuccess();
      //   }

      //   this.processLoading = false;
      // }
    },
    initWorkerToTransformRecurringMessages() {
      // Dynamically create the worker
      //let worker = new Worker("./../workers/worker-to-transform-recurring.js");
      this.worker.onmessage = async (event) => {
        const { type, transformedRecurringChunks } = event.data;

        switch (type) {
          case "chunkProcessed":
            try {
              console.log(
                "🚀 ~ worker.onmessage= ~ transformedRecurringChunks:",
                transformedRecurringChunks
              );
              // API call for each processed chunk
            } catch (error) {
              this.error = error.message;
              this.failure = true;
            }
            break;

          case "completed":
            this.loading = false;
            break;

          case "error":
            this.error = event.data.error;
            this.loading = false;
            break;

          default:
            console.warn("Unknown message type from worker:", type);
        }
      };

      this.worker.onerror = (error) => {
        this.error = `Worker Error: ${error.message}`;
        this.loading = false;
      };
    },
    handleSuccess() {
      this.loadingRecur = true;
      setTimeout(() => {
        this.selectedRecurrings = [];
        this.success = true;
        this.loadingRecur = false;
        this.processLoading = false;
      }, 1500);
    },
    handleError(error) {
      if (error.response) {
        this.errorMsg = error.response.data.message;
        //this.error = true;

        this.failure = true;
        setTimeout(() => {
          this.errorMsg = "";
          this.processLoading = false;
        }, 1000);
      }
    },
    getWelcomeDrips(dmnId) {
      this.processLoading = true;

      for (let i in this.selectedWelcomes) {
        Drip.get(
          "welcome",
          `?where[domain_id]=${this.selectedWelcomes[i].domain_id}&where[group_id]=${this.selectedWelcomes[i].group_id}&with[schedules]=name,type,is_active,after_days,after_mins,after_hours,from_when`,
          this.headersClientFrom()
        ).then((response) => {
          if (response.data.data) {
            this.welcomesForCopying = response.data.data.reduce(
              (array, obj) => {
                obj.is_active = 0;
                obj.created_at = moment().format("YYYY-MM-DD HH:mm:ss");
                obj.domain_id = dmnId;
                obj.schedule = obj.schedules[0];
                obj.schedule.is_active = 0;

                delete obj.id;
                delete obj.group_id;
                delete obj.schedules;

                array.push(obj);
                return array;
              },
              []
            );
          }

          if (
            this.isModerRole &&
            (!this.selectedClientTo.length || !this.selectedClientFrom.length)
          ) {
            return false;
          }

          Drip.createOrUpdate(
            "welcome",
            this.welcomesForCopying,
            false,
            this.isModerRole ? this.selectedClientTo : null
          )
            .then(() => {
              setTimeout(() => {
                this.selectedWelcomes = [];
                this.processLoading = false;
                this.success = true;
              }, 1500);
            })
            .catch((error) => {
              if (error.response) {
                this.errorMsg = error.response.data.message;
                this.failure = true;
                setTimeout(() => {
                  this.errorMsg = "";
                  this.processLoading = false;
                }, 1000);
              }
            });
        });
      }
    },
    getDataForSorting(dmn_id, is_active = 1) {
      this.loading = true;

      let scheduleRelation = null;

      switch (this.selectedScheduleRelation) {
        case "Recurring":
          scheduleRelation =
            "&with[schedules.audiences]=*&whereRelation[schedules]=type::recurring";
          break;
        case "Tail Recurring":
          scheduleRelation =
            "&with[schedules]=*&whereRelation[schedules]=type::tail-recurring";
          break;
        default:
          break;
      }

      Drip.get(
        "recurring",
        `?where[domain_id]=${dmn_id}&where[is_active]=${is_active}` +
          scheduleRelation,
        this.headersClientFrom()
      )
        .then((response) => {
          for (let recurring of response.data.data) {
            this.recurrings.push(recurring);

            if (
              recurring.schedules[0].audiences !== undefined &&
              recurring.schedules[0].audiences.length &&
              !this.itemsAudienceFilters[0].children.some(
                (el) => el.name == recurring.schedules[0].audiences[0].name
              )
            ) {
              this.itemsAudienceFilters[0].children.push({
                id: recurring.schedules[0].audiences[0].id,
                name: recurring.schedules[0].audiences[0].name,
              });
            }

            if (
              recurring.schedules &&
              !this.itemsSendTime[0].children.some(
                (el) => el.name == recurring.schedules[0].time
              )
            ) {
              this.itemsSendTime[0].children.push({
                id: recurring.schedules[0].time,
                name: recurring.schedules[0].time,
              });
            }

            if (
              recurring.schedules[0].audiences !== undefined &&
              recurring.schedules[0].audiences.length &&
              !this.audienceList.some(
                (el) => el.name == recurring.schedules[0].audiences[0].name
              )
            ) {
              this.audienceList.push({
                id: recurring.schedules[0].audiences[0].id,
                name: recurring.schedules[0].audiences[0].name,
              });
            }
          }

          this.deepCopyOfAllRecurrings = [...this.recurrings];

          this.loadingRecur = false;
        })
        .finally(() => {
          this.loadingRecur = false;
          this.loading = false;
        });
    },
    copyWelcomeDrips() {
      if (this.selectedWelcomeGroups && this.selectedWelcomeDrips) {
        for (let group of this.selectedWelcomeGroups) {
          this.selectedWelcomeDrips = this.selectedWelcomeDrips.map((el) => {
            el.created_at = moment().format("YYYY-MM-DD HH:mm:ss");
            el.group_id = group.group_id;
            el.schedule = el.schedules[0];
            delete el.schedules;

            return el;
          });

          return new Promise((resolve, reject) => {
            if (
              this.isModerRole &&
              (!this.selectedClientFrom.length || this.selectedClientTo.length)
            ) {
              return false;
            }

            Drip.createOrUpdate(
              "welcome",
              this.selectedWelcomeDrips,
              false,
              this.isModerRole ? this.selectedClientTo : null
            )
              .then((response) => {
                resolve(response);
              })
              .catch((error) => {
                reject(error);

                if (
                  error.response.status === 401 ||
                  error.response.status === 419
                ) {
                  this.$router.push({ name: "Login" });
                  this.failure = true;

                  return false;
                }
              });
          });
        }

        queueMicrotask(() => {
          this.success = true;
        });
      }
    },
    async copy() {
      if (
        (this.selectedTypes.some((el) => el.type === "Audience Filters") &&
          !this.selectedAudience.length) ||
        (this.selectedTypes.some((el) => el.type === "Recurring Drips") &&
          !this.selectedRecurrings.length) ||
        (this.selectedTypes.some((el) => el.type === "Welcome Drips") &&
          !this.selectedWelcomes.length)
      ) {
        this.warningText = "Select items you would like to copy!";
        this.showWarningPopUp = true;

        return false;
      }

      if (this.selectedDmnsFrom.length && this.selectedDmnsTo.length) {
        if (
          this.selectedRecurrings.length &&
          this.selectedTypes.some((obj) => obj.type === "Recurring Drips")
        ) {
          for (let i in this.selectedDmnsTo) {
            await this.sendRequestToCopyRecurringMessages(
              this.selectedDmnsTo[i].id
            );
          }
        }

        if (
          this.selectedWelcomes.length &&
          this.selectedTypes.some((obj) => obj.type === "Welcome Drips")
        ) {
          for (let i in this.selectedDmnsTo) {
            this.getWelcomeDrips(this.selectedDmnsTo[i].id);
          }
        }

        if (
          this.selectedAudience.length &&
          this.selectedTypes.some((obj) => obj.type === "Audience Filters")
        ) {
          this.processLoading = true;

          document.body.style.cursor = "wait";

          setTimeout(() => {
            this.processLoading = false;

            document.body.style.cursor = "default";

            this.selectedAudience = [];
            this.selectedRecurrings = [];
            this.selectedWelcomes = [];
          }, 1000);

          for (let i in this.selectedDmnsTo) {
            for (let aud of this.selectedAudience) {
              if (
                this.isModerRole &&
                (this.selectedClientTo || this.selectedClientFrom)
              ) {
                this.getClientSegments({
                  params: `?where[name]=${
                    aud.name
                  }&where[query]=${JSON.stringify(
                    aud.query
                  )}&where[domain_id]=${this.selectedDmnsTo[i].id}`,
                  headers: this.headersClientTo(),
                })
                  .then((response) => {
                    return response.data.data;
                  })
                  .then((response) => {
                    if (!response.length) {
                      Segments.store(
                        {
                          name: aud.name,
                          query: aud.query,
                          domain_id: this.selectedDmnsTo[i].id,
                          type: "audience",
                        },
                        this.headersClientTo()
                      ).then(() => {
                        this.success = true;
                      });
                    }
                  })
                  .catch((err) => {
                    if (err.response.status === 501) {
                      Segments.store(
                        {
                          name: aud.name,
                          query: aud.query,
                          domain_id: this.selectedDmnsTo[i].id,
                          type: "audience",
                        },
                        this.headersClientTo()
                      ).then(() => {
                        this.success = true;
                      });
                    }
                  });
              } else {
                this.getSegments(
                  `?where[name]=${aud.name}&where[query]=${JSON.stringify(
                    aud.query
                  )}&where[domain_id]=${this.selectedDmnsTo[i].id}`
                )
                  .then((response) => {
                    return response.data.data;
                  })
                  .then((response) => {
                    if (!response.length) {
                      Segments.store({
                        name: aud.name,
                        query: aud.query,
                        domain_id: this.selectedDmnsTo[i].id,
                        type: "audience",
                      }).then(() => {
                        this.success = true;
                      });
                    }
                  })
                  .catch((err) => {
                    if (err.response.status === 501 || err.response.status === 502) {
                      Segments.store({
                        name: aud.name,
                        query: aud.query,
                        domain_id: this.selectedDmnsTo[i].id,
                        type: "audience",
                      }).then(() => {
                        this.success = true;
                      });
                    }
                  });
              }
            }
          }
        }
      }
    },
    checkMainWarnings() {
      if (
        !this.selectedDmnsFrom.length ||
        (!this.selectedDmnsTo.length && this.selectedTypes.length)
      ) {
        this.showWarningPopUp = true;
        this.warningText = this.selectedDmnsTo.length
          ? "Select domain(s) to obtain items from!"
          : "Select domain(s) to obtain items from and to copy to!";
      }
    },
  },
  watch: {
    selectedScheduleRelation() {
      this.getRecurringMessages();
    },
    selectedRecurringStatus() {
      this.recurrings = [];

      this.getRecurringMessages();
      // for (let dmnId of this.selectedDmnsFrom) {
      //   this.getDataForSorting(dmnId, this.selectedRecurringStatus);
      // }
    },
    selectedClientTo(value) {
      this.loading = true;
      this.selectedDmnsTo = [];

      Domains.getClientDomains({
        Accept: "application/json",
        client: value,
      })
        .then((response) => {
          this.dmnsTo = [];

          this.dmnsTo.push(response.data.data);
        })
        .catch((error) => {
          if (error.response) {
            this.errorMsg = error.response.data.message;
            this.failure = true;
            setTimeout(() => {
              this.errorMsg = "";
              this.processLoading = false;
            }, 1000);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    selectedClientFrom(value) {
      this.loading = true;
      this.selectedDmnsFrom = [];

      setTimeout(() => {
        Domains.getClientDomains({
          Accept: "application/json",
          client: value,
        })
          .then((response) => {
            this.dmnsFrom = [];

            this.dmnsFrom.push(response.data.data);
          })
          .catch((error) => {
            if (error.response) {
              this.errorMsg = error.response.data.message;
              this.failure = true;
              setTimeout(() => {
                this.errorMsg = "";
                this.processLoading = false;
              }, 1000);
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }, 1500);
    },
    selectedDmnsTo() {
      //this.checkMainWarnings();
    },
    selectedDmnsFrom(dmn) {
      let headers =
        this.selectedClientFrom.length || this.selectedClientTo.length
          ? {
              Accept: "application/json",
              client: this.selectedClientFrom,
            }
          : {
              Accept: "application/json",
            };
      //this.checkMainWarnings();
      //console.log(dmn, "dmn");

      if (!dmn.length) {
        this.loadingRecur = true;
        this.loadingWelc = true;
        this.loadingAud = true;

        this.recurrings = [];
        this.welcomes = [];
        this.audience = [];

        this.loadingRecur = false;
        this.loadingWelc = false;
        this.loadingAud = false;
      } else if (dmn.length && this.selectedTypes.length) {
        if (this.selectedTypes.find((el) => el.type === "Recurring Drips")) {
          this.loadingRecur = true;
          this.recurrings = [];

          this.getRecurringMessages();
          // this.getDataForSorting(
          //   dmn[i].id,
          //   this.selectedRecurringStatus || 1
          // );
        }

        for (let i in dmn) {
          if (
            this.selectedTypes.findIndex(
              (el) => el.type === "Recurring Drips"
            ) === -1
          ) {
            this.recurrings = [];
            this.loadingRecur = false;
          } else if (
            this.selectedTypes.findIndex(
              (el) => el.type === "Recurring Drips"
            ) === -1
          ) {
            this.recurrings = [];
            this.loadingRecur = false;
          }

          if (this.selectedTypes.find((el) => el.type === "Welcome Drips")) {
            this.loadingWelc = true;
            this.welcomes = [];

            Drip.get(
              "welcome",
              `?where[domain_id]=${dmn[i].id}&group_by=group_id&with[schedules.audiences]=*`,
              this.headersClientFrom()
            ).then((response) => {
              for (let welcome of response.data.data) {
                this.welcomes.push(welcome);
              }
              this.loadingWelc = false;
            });
          } else if (
            this.selectedTypes.findIndex(
              (el) => el.type === "Welcome Drips"
            ) === -1
          ) {
            this.welcomes = [];
            this.loadingWelc = false;
          }

          if (this.selectedTypes.find((el) => el.type === "Audience Filters")) {
            this.loadingAud = true;
            this.audience = [];

            if (this.isModerRole && this.selectedClientFrom.length) {
              this.getClientSegments({
                params: `?where[type]=audience&where[domain_id]=${dmn[i].id}&where[is_system]=0`,
                headers: this.headersClientFrom(),
              }).then((response) => {
                for (let filter of response.data.data) {
                  this.audience.push(filter);
                }
                this.loadingAud = false;
              });

              return false;
            }

            this.getSegments(
              `?where[type]=audience&where[domain_id]=${dmn[i].id}&where[is_system]=0`
            ).then((response) => {
              for (let filter of response.data.data) {
                this.audience.push(filter);
              }
              this.loadingAud = false;
            });
          } else if (
            this.selectedTypes.findIndex(
              (el) => el.type === "Audience Filters"
            ) === -1
          ) {
            this.audience = [];
            this.loadingAud = false;
          }
        }
      }
    },
    selectedTypes(new_array, old_array) {
      let dmnsFrom = this.selectedDmnsFrom.length ? this.selectedDmnsFrom.map((el) => el.id) : [];

      !this.recurrings.length ? (this.loadingRecur = true) : null;
      !this.welcomes.length ? (this.loadingWelc = true) : null;
      !this.audience.length ? (this.loadingAud = true) : null;

      this.checkMainWarnings();

      if (dmnsFrom.length) {
        if (
          new_array.find((el) => el.type === "Recurring Drips") &&
          (!old_array.find((el) => el.type === "Recurring Drips") ||
            !old_array.length)
        ) {
          this.getRecurringMessages();
          // this.getDataForSorting(
          //   this.selectedDmnsFrom[i].id,
          //   this.selectedRecurringStatus || 1
          // );
        }

        for (let i in this.selectedDmnsFrom) {
          if (
            new_array.findIndex((el) => el.type === "Recurring Drips") === -1
          ) {
            this.recurrings = [];
            this.deepCopyOfAllRecurrings = [];
            this.loadingRecur = false;
          }

          if (
            new_array.find((el) => el.type === "Welcome Drips") &&
            (!old_array.find((el) => el.type === "Welcome Drips") ||
              !old_array.length)
          ) {
            this.welcomes;

            Drip.get(
              "welcome",
              `?where[domain_id]=${dmnsFrom.toString()}&group_by=group_id&with[schedules.audiences]=*`,
              this.headersClientFrom()
            ).then((response) => {
              this.welcomes = response.data.data;
              // for (let welcome of response.data.data) {
              //   this.welcomes.push(welcome);
              // }
              this.loadingWelc = false;
            });
          } else if (
            new_array.findIndex((el) => el.type === "Welcome Drips") === -1
          ) {
            this.welcomes = [];
            this.loadingWelc = false;
          }

          if (
            new_array.find((el) => el.type === "Audience Filters") &&
            (!old_array.find((el) => el.type === "Audience Filters") ||
              !old_array.length)
          ) {
            if (this.isModerRole && this.selectedClientFrom.length) {
              this.getClientSegments({
                params: `?where[type]=audience&where[domain_id]=${this.selectedDmnsFrom[i].id}&where[is_system]=0`,
                headers: this.headersClientFrom(),
              }).then((response) => {
                for (let filter of response.data.data) {
                  this.audience.push(filter);
                }
                this.loadingAud = false;
              });

              return false;
            }

            this.getSegments(
              `?where[type]=audience&where[domain_id]=${this.selectedDmnsFrom[i].id}&where[is_system]=0`
            ).then((response) => {
              for (let filter of response.data.data) {
                this.audience.push(filter);
              }
              this.loadingAud = false;
            });
          } else if (
            new_array.findIndex((el) => el.type === "Audience Filters") === -1
          ) {
            this.audience = [];
            this.loadingAud = false;
          }
        }
      }
    },
    // dmnsTo() {
    //   if (this.dmnsTo.length || this.dmnsTo.length === 0 || this.error) {
    //     this.loading = false;
    //   }
    // },
    selectedAudienceFiltersForSorting() {
      this.getRecurringMessages();
    },
    selectedSendTimeForSorting() {
      this.getRecurringMessages();
    },
  },
};
</script>

<style scoped>
.hover--grey:hover {
  background-color: #eeeeee;
}
.active--blue:selected {
  background-color: #c0daf3 !important;
}
small {
  color: #838181;
}
.border-radius-4 {
  border-radius: 4px !important;
}
.step-number {
  font-size: 9px;
  color: #ffffff;
  font-weight: 700;
  background: #3171b3;
  border-radius: 100%;
  padding: 4px 7px;
}
.tag:hover {
  color: #646262;
}
.tag {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #7f7f7f;
  padding: 6px 10px;
  /* width: 38px; */
  height: 25px;
  background: #dfe1e5;
  border-radius: 4px;
}
.inActiveStatus {
  color: #e45b54;
}
.activeStatus {
  color: #52a451 !important;
}
.inActiveStatusSign {
  /* Rectangle 189 */
  /* position: absolute; */
  width: 10px;
  height: 10px;
  left: 8px;
  top: 15px;

  /* Red */
  background: #e45b54;
  border-radius: 1px;
}

.activeStatusSign {
  /* Rectangle 189 */
  /* position: absolute; */
  width: 10px;
  height: 10px;
  left: 8px;
  top: 15px;

  /* Green */
  background: #52a451 !important;
  border-radius: 1px;
}
.font-size-11 {
  font-size: 11px !important;
}
.font-weight-400 {
  font-weight: 400 !important;
}

.form-control {
  width: 200px;
}
.col-md-9.col-sm-12 div + div {
  margin: 0 0 14px 0;
}
option,
select {
  color: #fff;
}
</style>
